import { render, staticRenderFns } from "./OvPaymentSplit.vue?vue&type=template&id=f4feefaa&scoped=true&"
import script from "./OvPaymentSplit.vue?vue&type=script&lang=js&"
export * from "./OvPaymentSplit.vue?vue&type=script&lang=js&"
import style0 from "./OvPaymentSplit.vue?vue&type=style&index=0&id=f4feefaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4feefaa",
  null
  
)

export default component.exports